import Swiper, { Autoplay, EffectFade } from "swiper";

export default () => {
	(function ($) {
		if ($('.page-header--jumbotron').length) {
			// init Swiper:
			const swiper = new Swiper('.page-header--jumbotron .swiper', {
				modules: [Autoplay, EffectFade],
				slidesPerView: 1,
				loop: true,
				speed: 1500,
				autoplay: {
					delay: 5000,
				},
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
			});
		}
	})(jQuery);
}
